import { useAuth0 } from '@auth0/auth0-react';
import Fade from "@material-ui/core/Fade";
import Dialog from "@material-ui/core/Dialog";
import PreSchoolService from 'Lib/API/PreSchool';
import AddParticipantIcon from 'assets/icons/AddParticipantIcon.svg';
import BackIcon from 'assets/icons/Back.png';
import { ReactComponent as PlusIcon } from 'assets/icons/plus.svg';
import AlertDialog from 'components/Dialog/index';
import Button from 'components/button/Button';
import ShareDocumentsModal from 'pages/NewFinance/Documents/ShareDocumentsModal';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toastr } from 'react-redux-toastr';
import { useHistory, useLocation, useParams } from "react-router-dom";
import AddParticipantModal from './AddParticipantModal/AddParticipantModal';
import ParticipantDetailsTable from './ParticipantDetailsTable/ParticipantDetailsTable';
import { AddParticipant, ButtonGroup, ClassInfo, EditClass, Header, ShareClass, Title, Wrapper } from './Theme';

const EventParticipantDetails = () => {
    const [openFilter, setOpenFilter] = useState(false)
    const history = useHistory();
    const { search } = useLocation();
    const searchParams = new URLSearchParams(search);



    const [eventInfo, setEventInfo] = useState({});
    const [loading, setLoading] = useState(false);
    const [participantsPage, setParticipantsPage] = useState(1);
    const [count, setCount] = useState();
    const [rows, setRows] = useState([]);
    const [renderCount, setRenderCount] = useState(0);
    const [openAddParticipant, setOpenAddParticipant] = useState(false);
    const [openSharePaymentModal, setOpenSharePayment] = useState(false)
    const [dataRowSharePayment, setDataRowSharePayment] = useState({})
    const [dataRowsSharePayment, setDataRowsSharePayment] = useState([])
    const [isMultipleSharePayment, setIsMultipleSharePayment] = useState(false)
    const [searchValue, setSearchValue] = React.useState("");
    const [getEventLoading, setGetEventLoading] = useState(false);
    const [ticketData, setTicketData] = useState({});
    const [eventTicketVariants, setEventTicketVariants] = useState([]);
    const [confirmClose, setConfirmClose] = useState(false);
    const [sorting, setSorting] = useState({
        sort: {},
        search: undefined,
      });
    
    const dispatch = useDispatch();
    const [addParticipantLoading, setAddParticipantLoading] = React.useState(false);

    const { id: eventId } = useParams();
    const participantGroupId = searchParams.get("groupId");

    const transformVariantInfoToArray = (variantInfo) => {
        const newVariantInfo = [];
        if(Object.keys(variantInfo).length === 0) return newVariantInfo;
        for (const key in variantInfo) {
          newVariantInfo.push({
            label: key,
            value: key,
          })
        }
        return newVariantInfo;
      }

    const getEventHandler = async () => {
        setGetEventLoading(true);
        try {
            const token = await getAccessTokenSilently();
            const response = await PreSchoolService.getEventById(token, eventId);
            const data = response?.result;
            setEventInfo(data);
            const ticketPrice = data?.eventPricing?.prices?.find((price) => price.type === "onRegistration")
            if(!ticketPrice) return;
            setTicketData(ticketPrice);
            if(ticketPrice && ticketPrice?.variant && Object.keys(ticketPrice?.variantInfo).length > 0) {
                const ticketVariants = transformVariantInfoToArray(ticketPrice?.variantInfo);
                setEventTicketVariants(ticketVariants);
            }
            


        } catch (error) {
            toastr.error('Error', error?.data?.message || 'Something went wrong');
        } finally {
            setGetEventLoading(false);
        }
      };
   
    useEffect(() => {
        if (eventId) {
            getEventHandler();
        }
      }, [eventId, getAccessTokenSilently]);
    


    const { getAccessTokenSilently } = useAuth0();

    const getClassParticipants = async (page) => {
        const currentPage = page || participantsPage;

        setLoading(true);
        try {
            const token = await getAccessTokenSilently();
            const data = {
                eventId,
                ...sorting,
            };
            if(participantGroupId) {
                data.groupId = participantGroupId;
            }
            const response = await PreSchoolService.getEventParticipants(
                token,
                currentPage,
                30,
                data
            );
            setCount(response.payload?.pagination?.count);
            setRows(response?.payload?.data);

        } catch (error) {
            toastr.error('Error', error?.data?.message || 'Something went wrong');
        } finally {
            setLoading(false);
        }
    };
    const handleOpenFilter = () => {
        setOpenFilter(!openFilter)
    }
    const handleInputChange = (e) => {
        const inputValue = e.target.value;
        const regex = /[\*\(\)\+]/;
        if (!regex.test(inputValue)) {
          setSearchValue(inputValue);
        }
      };

    const addParticipantHandler = async ({
        contactId,
        doNotCreateCharge,
        firstName,
        lastName,
        ticketVariant,
    }) => {
        setAddParticipantLoading(true)
        const token = await getAccessTokenSilently();
        const payload = {
          eventId,
          contactId,
          doNotCreateCharge,
          ticket: {
                id: ticketData?._id,
                title: ticketVariant || ticketData?.title,
                numberOfTickets: 1,
            },
        }
        PreSchoolService.addParticipantToEvent(token, payload).then((response) => {
            toastr.success('Success', `${firstName} ${lastName} added to ${eventInfo?.eventName}`);
            setOpenAddParticipant(false)
            getClassParticipants()
        }).catch((error) => {
          toastr.error('Error', error?.data?.message || 'Something went wrong');
        }).finally(() => {
          setAddParticipantLoading(false)
        })    
      }

    const onSharePaymentLinkClick = (row) => {
        setOpenSharePayment((prev) => !prev);
        setDataRowSharePayment(row);
        setIsMultipleSharePayment(false);
    }
    const onSharePaymentLinkMultipleClick = (rows) => {
        setOpenSharePayment((prev) => !prev);
        setIsMultipleSharePayment(true);
        setDataRowsSharePayment(rows);
    }
    useEffect(() => {
        if (searchValue === "") {
          setSorting({ ...sorting, search: undefined });
        } else {
          setSorting({ ...sorting, search: searchValue });
        }
        setParticipantsPage(1);
      }, [searchValue]);


      const closeModal = () => {
        setConfirmClose(true);
      }
      const confirmCloseHandler = () => {
        setConfirmClose(false);
        setOpenAddParticipant(false);
      }


    return (
        <Wrapper className='mt-10'>
            <Header>
                <ClassInfo>
                    <Title><img src={BackIcon} alt='Back' onClick={() => history.push("/newEvents")} />{eventInfo?.eventName}</Title>
                    <ButtonGroup>
                        <Button
                            variant="primary"
                            onClick={() => {
                                setOpenAddParticipant(true)
                            }}
                        >
                            <PlusIcon />
                            <span>Add New Participant</span>
                        </Button>
                    </ButtonGroup>
                </ClassInfo>

                {/* <FilterWrapper>
                    <Filter onClick={handleOpenFilter} isFilterOpen={openFilter}>
                        <img src={openFilter ? FilterWhiteIcon : FilterIcon} alt='Filter-Participant' />Filter
                    </Filter>
                    <SearchDownShift
                        items={[]}
                        name={searchValue}
                        setName={setSearchValue}
                        placeHolder="Search"
                        autoFocus
                    />
                </FilterWrapper>
                {openFilter && <PartricipantFilter openFilter={openFilter} setOpenFilter={setOpenFilter} />} */}
            </Header>
            <ParticipantDetailsTable getClassParticipants={getClassParticipants} sorting={sorting} setSorting={setSorting}
                setParticipantsPage={setParticipantsPage} participantsPage={participantsPage}
                count={count} setCount={setCount} rows={rows} setRows={setRows} loading={loading}
                 eventId={eventId} setRenderCount={setRenderCount}
                onSharePaymentLinkClick={onSharePaymentLinkClick}
                onSharePaymentLinkMultipleClick={onSharePaymentLinkMultipleClick}
                handleInputChange={handleInputChange}
                searchValue={searchValue}
                participantGroupId={participantGroupId}
                isMultiEvent={eventInfo?.multiEvents}
                eventDates={eventInfo?.multiEventsDates || []}
                multiEventsType={eventInfo?.multiEventsType}
                isFreeEvent={!!eventInfo?.freeEvent}
            />
            <Dialog
                className={``}
                onClose={closeModal}
                open={openAddParticipant}
                PaperProps={{
                    style: {
                      width: "500px",
                      height: ticketData?.variant ? "460px" : "400px",
                      overflowX: "hidden",
                      borderRadius: "10px",
                    },
                  }}
                  fullWidth
                  maxWidth={"md"}
                >
                <Fade in={openAddParticipant}>
                    <AddParticipantModal  
                        closeModal={closeModal}
                        eventId={eventId}
                        ticketData={ticketData}
                        eventTicketVariants={eventTicketVariants}
                        getEventLoading={getEventLoading}
                        addParticipantHandler={addParticipantHandler}
                        addParticipantLoading={addParticipantLoading}
                    />
                </Fade>
            </Dialog>
            {openSharePaymentModal &&
                <Dialog
                open={openSharePaymentModal}
                disableEnforceFocus
                onClose={() => {
                    setOpenSharePayment(false);
                }}
                PaperProps={{
                    style: {
                    width: "888px",
                    height: "637px",
                    overflowX: "hidden",
                    borderRadius: "22px",
                    },
                }}
                fullWidth
                maxWidth={"md"}
                >
                <ShareDocumentsModal
                    closeModal={() => {
                    setOpenSharePayment(false);
                    }}
                    type={'sharePaymentLink'}
                    sharePaymentType={"event"}
                    disablePaymentLink={true}
                    accountId={!isMultipleSharePayment ? dataRowSharePayment?.account?._id : ""}
                    accountName={!isMultipleSharePayment ? dataRowSharePayment?.account?.family_name : ""}
                    participantId={!isMultipleSharePayment ? dataRowSharePayment?._id : ""}
                    defaultEmail={(!isMultipleSharePayment && dataRowSharePayment?.email) ? [dataRowSharePayment?.email] : []}
                    isMultiple={isMultipleSharePayment}
                    isMultipleTypes={false}
                    participantsIds={isMultipleSharePayment ? dataRowsSharePayment?.map((row) => row?._id) : []}
                    documentType="paymentLink"
                />
                </Dialog>
            }
            <AlertDialog
                open={confirmClose}
                handleClose={() => setConfirmClose(false)}
                onDecline={() => {
                setConfirmClose(false);
                }}
                onAccept={confirmCloseHandler}
                title={"Are you sure?"}
                description={"Do you want to discard the changes you made?"}
            />
        </Wrapper>
    );
};

export default EventParticipantDetails;